export default __webpack_public_path__ + "static/media/7B95A6A9-B35D-4135-B366-66C36C346E24_1_102_o.b1715fba.jpeg";